import {
  RiBuilding2Line,
  RiCpuLine,
  RiGroupLine,
  RiPuzzleLine,
  RiSparklingLine,
  RiShapesLine,
  RiUserLine,
} from '@remixicon/react';
import { ConfluenceSearchIcon } from '../components/confluence/ConfluenceSearchIcon';
import {
  DocsIcon,
  ResourceIcon,
  UpdatesIcon,
  TemplatesIcon,
  CatalogIcon,
  AllIcon,
} from '@xlrt/components';
import { IconType } from '../types/search.types';

export const typeIconMap: Record<string, IconType> = {
  techdocs: DocsIcon,
  announcements: UpdatesIcon,
  confluence: ConfluenceSearchIcon,
  Component: RiCpuLine,
  Domain: RiBuilding2Line,
  API: RiPuzzleLine,
  Resource: ResourceIcon,
  Template: TemplatesIcon,
  Group: RiGroupLine,
  User: RiUserLine,
  System: RiShapesLine,
  AiResource: RiSparklingLine,
  All: AllIcon,
  Catalog: CatalogIcon,
};
